import React from 'react'
import PropTypes from 'prop-types'
import { Elements, StripeProvider } from 'react-stripe-elements'
import OrderInfo from './OrderInfo'

export default class Application extends React.Component {
  render() {
    return (
      <StripeProvider apiKey={this.props.stripeKey}>
        <div>
          <Elements>
            <OrderInfo />
          </Elements>
        </div>
      </StripeProvider>
    )
  }
}

Application.propTypes = {
  stripeKey: PropTypes.string,
}
